import { render, staticRenderFns } from "./InDetail.vue?vue&type=template&id=6a1fc18c"
import script from "./InDetail.vue?vue&type=script&lang=js"
export * from "./InDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_2ea6a45124a3d4733daba14b311fba49/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports